<div class="container mt-5 mb-5">
    <div class="row">
        <div class="d-none d-lg-block col-lg-2 me-auto">
            <ul class="nav prog-info-nav flex-column">
                <li class="nav-item">
                    <a href="https://edit.testing.tsa.gov/precheck" target="_blank" rel="noopener noreferrer" class="nav-link" tabindex="0">
                        <span class="tsapre-link">TSA PreCheck</span><sup>&reg;&nbsp;</sup>
                        <i style="width: 14px;" class="uswds-icon icon-launch"></i>
                    </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" tabindex="0" [routerLink]="['/programs-info']" [queryParams]="{code: 'UP'}" [routerLinkActive]="['active']" (click)="setSelected('UP')" (keyup)="setSelected('UP')">Global Entry</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" tabindex="0" [routerLink]="['/programs-info']" [queryParams]="{code: 'NH'}" [routerLinkActive]="['active']" (click)="setSelected('NH')" (keyup)="setSelected('NH')">NEXUS</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link"  tabindex="0" [routerLink]="['/programs-info']" [queryParams]="{code: 'SH'}" [routerLinkActive]="['active']" (click)="setSelected('SH')" (keyup)="setSelected('SH')">SENTRI</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" tabindex="0" [routerLink]="['/programs-info']" [queryParams]="{code: 'FAST'}" [routerLinkActive]="['active']" (click)="setSelected('FAST')" (keyup)="setSelected('FAST')">FAST</a>
                  </li>
              </ul>
        </div>

        <!-- Middle Column -->
        <div class="col-12 col-lg-7">
            <div>
                <h2><span class="fw-bold">{{selectedProgram.name | translate}}:&nbsp;</span><span>{{selectedProgram.bestFor | translate}}</span></h2>
                <p [innerHTML]="selectedProgram.description | translate"></p>
            </div>

            <div class="pt-3">
                <h3 class="fw-bold">{{'MODAL.BENEFITS' | translate}}</h3>

                <div class="d-flex pt-3 gap-3">
                    <div class="benefit-container d-flex flex-column" *ngFor="let benefit of selectedProgram.benefits; let i = index">
                        <span class="benefit-icon" [innerHTML]="benefit.icon"></span>
                        <span>{{benefit.description | translate}}</span>
                    </div>
                </div>        
            </div>

            <!-- Apply card mobile -->
            <div class="mt-3 d-block d-lg-none">
                <div class="card prog-info-card m-auto">
                    <div class="card-header">
                      <img class="global-entry" src="{{selectedProgram.logo}}" alt="{{selectedProgram.logoAlt| translate}}">
                    </div>
    
                    <div class="card-body">
                        <div class="ms-auto">
                          <h3 class="program-price program-price-air"><b>${{selectedProgram.costHeader.price}}</b></h3>
                          <span style="display: block;" *ngFor="let costInfo of selectedProgram.costHeader.costInfo; let i = index">{{ costInfo | translate}}</span>
                        </div>
    
                        <div class="pt-4">
                            <a class="btn btn-primary" tabindex="0" (click)="getStarted(selectedProgram.code);" (keyup.enter)="getStarted(selectedProgram.code);"
                            target="_blank" rel="noopener noreferrer">{{'HOME.APPLY_NOW' | translate}}</a>  
                        </div>
                    </div>
                </div>
            </div>


            <div class="pt-5">
                <h3 class="fw-bold">{{'PROGRAM_LANDING_PAGE.WHAT_YOU_SHOULD_KNOW' | translate}}</h3>

                <div class="accordion accordion-flush top-faq-accordion" id="prog-info-accordion">
                    @if (selectedProgram.code === 'UP') {
                        <app-what-to-know-up class="accordion-flush"></app-what-to-know-up>
                    }
                    @if (selectedProgram.code === 'NH') {
                        <app-what-to-know-nh class="accordion-flush"></app-what-to-know-nh>
                    }
                    @if (selectedProgram.code === 'SH') {
                        <app-what-to-know-sh class="accordion-flush"></app-what-to-know-sh>
                    }
                    @if (selectedProgram.code === 'FAST') {
                        <app-what-to-know-fast class="accordion-flush"></app-what-to-know-fast>
                    }
                </div>     
            </div>

            <div class="card prog-info-find-best-card ">
                <div class="card-body">
                    <h4>{{ 'HOME.FIND_WHAT_WORKS' | translate}}</h4>
                    <p class="card-text">{{'HOME.FIND_WHAT_WORKS_INSTRUCTIONS' | translate}}</p>
                    <a href="#" class="btn btn-light mt-auto fw-bold"  data-bs-toggle="modal" data-bs-target="#comparison-wizard" translate>HOME.START</a>
                </div>
            </div>
        </div>

        <div class="col-lg-3 d-none d-lg-block">
            <div class="card prog-info-card">
                <div class="card-header">
                  <img class="global-entry" src="{{selectedProgram.logo}}" alt="{{selectedProgram.logoAlt| translate}}">
                </div>

                <div class="card-body">
                    <div class="ms-auto">
                      <h3 class="program-price program-price-air"><b>${{selectedProgram.costHeader.price}}</b></h3>
                      <span style="display: block;" *ngFor="let costInfo of selectedProgram.costHeader.costInfo; let i = index">{{ costInfo | translate}}</span>
                    </div>

                    <div class="pt-4">
                        <a class="btn btn-primary" tabindex="0" (click)="getStarted(selectedProgram.code);" (keyup.enter)="getStarted(selectedProgram.code);"
                        target="_blank" rel="noopener noreferrer">{{'HOME.APPLY_NOW' | translate}}</a>  
                    </div>
                </div>
            </div>
        </div>
    </div>    
</div>
